import { isAdminNotConsultant } from "@/js/http/auth.js";
import AdminProducersSubMenusLinks from "@/components/menu/sub-menus/producers/AdminProducersSubMenusLinks.vue";
import ProducerDetails from "@/components/producers/ProducerDetails.vue";
export default {
  name: "AdminProducerDetails",
  components: {
    AdminProducersSubMenusLinks: AdminProducersSubMenusLinks,
    ProducerDetails: ProducerDetails
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      id: null,
      isWinery: false,
      isDistillery: false,
      searchCriterias: null,
      returnRoute: "adminProducerList"
    };
  },
  created: function created() {
    this.id = +this.$route.params.id;
    this.isWinery = this.$route.params.isWinery;
    this.isDistillery = this.$route.params.isDistillery;
    this.searchCriterias = this.$route.params.searchCriterias;
  },
  methods: {
    isAdminNotConsultant: isAdminNotConsultant
  }
};